import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { motion } from "motion/react";
import servicesData from "../../data/servicesData.json";

const Process = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 }
        }
    }

    const cardVariants = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    }

    const progressVariants = {
        hidden: { width: 0 },
        visible: (progress) => ({
            width: `${progress}%`,
            transition: { duration: 1, ease: "easeOut", delay: 0.3 }
        })
    }

    return (
        <section className="section-lg bg-light overflow-hidden" id="growth-process">
            <Container>
                <Row>
                    <Col xs={12} className='mb-5'>
                        <motion.h6 initial={{ opacity: 0, y: -30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="underline-after position-relative text-center z-0">
                            <span className="position-relative z-1 bg-white text-primary px-3">Our Process</span>
                        </motion.h6>
                        <motion.h1 initial={{ opacity: 0, scale: 0 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="d-block text-gradiant text-center fw-semibold">A simple, repeatable playbook</motion.h1>
                    </Col>
                </Row>
                <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
                    <Row className="g-4 justify-content-center">
                        {servicesData.process.map((step) => (
                            <Col md={6} lg={3} key={step.id}>
                                <motion.div variants={cardVariants} whileHover={{ y: -10, transition: { duration: 0.3 } }}>
                                    <Card className="border-0 shadow-sm h-100">
                                        <Card.Body>
                                            <div className="d-flex align-items-center mb-2">
                                                <motion.span className="badge bg-success me-2" whileHover={{ scale: 1.1 }}>
                                                    {step.step}
                                                </motion.span>
                                                <h6 className="mb-0">{step.title}</h6>
                                            </div>
                                            <p className="text-secondary">{step.description}</p>
                                            <ul className="list-unstyled lh-lg small mb-3">
                                                {step.items.map((item, idx) => (
                                                    <motion.li key={idx} className="d-flex align-items-center"
                                                        initial={{ opacity: 0, x: -10 }}
                                                        whileInView={{ opacity: 1, x: 0 }}
                                                        viewport={{ once: true }}
                                                        transition={{ delay: idx * 0.1 + 0.3 }}
                                                    >
                                                        <i className={`${item.icon} text-success me-2`}></i> {item.text}
                                                    </motion.li>
                                                ))}
                                            </ul>
                                        </Card.Body>
                                        <Card.Footer className="bg-white border-0">
                                            <div className="progress" style={{ height: '6px' }}>
                                                <motion.div className="progress-bar bg-success"
                                                    role="progressbar"
                                                    aria-valuenow={step.progress}
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                    variants={progressVariants}
                                                    initial="hidden"
                                                    whileInView="visible"
                                                    viewport={{ once: true }}
                                                    custom={step.progress}
                                                ></motion.div>
                                            </div>
                                        </Card.Footer>
                                    </Card>
                                </motion.div>
                            </Col>
                        ))}
                    </Row>
                </motion.div>
            </Container>
        </section>
    )
}

export default Process;